// extracted by mini-css-extract-plugin
module.exports = {"root":"_1dcsL","linkBreakToNewLine":"_1jyoS","headingImage":"RHyrd","headingSpaceBelow":"_3NpWr","subHeadingAndContentItem":"BrMgs","subHeadingAndContentContainer":"_3HwJu"};